<style lang="scss" scoped>
.senior-funder-btn {
  text-transform: none;
  font-weight: normal;
  font-size: 0.875rem;

  &.selected {
    font-weight: bold;
  }
}
</style>

<template>
  <div>
    <v-row>
      <v-col>
        <span class="black--text heading">
          Sr. Funders
        </span>
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col>
        <div v-for="seniorFunder in seniorFunders" :key="seniorFunder._id">
          <v-btn
            text
            small
            class="senior-funder-btn"
            :color="value === seniorFunder ? 'primary' : null"
            :class="{ 'selected': value === seniorFunder }"
            :id="`groups-senior-funder-btn-${seniorFunder._id}`"
            @click="() => $emit('input', seniorFunder)"
          >
            {{ seniorFunder.display_name }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import userMixin from '@/mixins/userMixin';


export default {
  name: 'AdminGroupsSeniorFunders',
  mixins: [userMixin],
  props: {
    value: Object,
  },
  data: () => ({
    seniorFunders: [],
    loading: false,
  }),
  methods: {
    fetch() {
      this.loading = true;

      const params = {
        group: 'loans:senior_funders',
        active_only: true,
      };
      this.$requests.get('/v1/users', { params })
        .then(response => {
          this.seniorFunders = this.resolveUsers(response.data);
        })
        .catch(() => {
          this.$toast.error('Unable to resolve senior funders list...', { timeout: 3000 });
        })
        .then(() => { this.loading = false; });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
